import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
<path d="M0 6590 l0 -3650 80 0 c47 0 80 -4 80 -10 0 -6 60 -10 160 -10 128 0
160 3 160 14 0 19 85 26 301 26 157 0 179 2 179 16 0 14 40 15 400 12 220 -1
400 1 400 5 0 5 36 7 80 5 54 -2 81 1 84 8 5 12 39 12 173 -2 44 -4 116 -2
184 6 85 10 114 10 117 2 5 -15 162 -17 162 -2 0 6 33 10 80 10 47 0 80 4 80
10 0 6 9 10 21 10 11 0 17 5 14 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10 3 -5 29
-10 56 -10 34 0 48 4 43 11 -5 9 37 9 84 0 1 -1 2 -9 2 -19 0 -18 37 -42 65
-42 8 0 15 -7 15 -15 0 -8 7 -15 15 -15 7 0 18 -6 22 -13 4 -7 20 -20 34 -29
14 -9 49 -39 76 -66 28 -27 60 -53 72 -57 11 -3 21 -10 21 -15 0 -5 12 -16 28
-24 15 -8 43 -28 62 -45 19 -16 46 -36 60 -43 14 -7 48 -30 75 -51 28 -20 55
-41 60 -45 6 -4 28 -16 50 -27 22 -11 54 -29 70 -41 17 -12 40 -25 53 -29 12
-3 22 -11 22 -16 0 -5 7 -9 16 -9 9 0 28 -8 42 -18 15 -10 35 -22 45 -25 9 -4
17 -11 17 -17 0 -6 -46 -10 -122 -11 -149 -1 -193 -4 -373 -19 -77 -6 -210
-13 -295 -16 -84 -2 -170 -9 -190 -14 -19 -5 -96 -12 -170 -15 -184 -8 -260
-14 -290 -25 -14 -5 -50 -10 -81 -12 -35 -3 -67 -12 -85 -25 -16 -11 -35 -19
-42 -17 -7 1 -8 0 -2 -3 5 -2 10 -11 10 -18 0 -14 60 -31 93 -26 9 1 20 -5 23
-13 5 -13 27 -16 133 -16 115 -1 234 -10 486 -39 79 -9 242 -20 520 -37 591
-34 1231 -48 1830 -41 514 7 1186 29 1390 47 100 8 239 18 495 35 50 3 228 23
430 48 151 19 175 24 178 40 6 32 -25 54 -86 60 -144 16 -199 26 -227 41 -34
18 -65 21 -65 6 0 -5 -25 -9 -55 -8 -29 1 -52 5 -49 9 3 5 -19 8 -48 7 -29 0
-75 2 -103 5 -27 4 -131 12 -230 17 -99 6 -202 13 -230 15 -27 2 -125 5 -217
7 -93 2 -168 6 -168 11 0 4 10 11 23 16 75 29 419 233 457 271 3 3 17 11 32
19 15 8 25 18 22 23 -3 4 2 8 10 8 20 0 20 7 0 27 -13 13 -19 14 -40 3 -13 -7
-26 -11 -29 -8 -10 10 53 58 85 65 33 6 34 6 18 -11 -10 -9 -22 -14 -28 -11
-5 3 -10 3 -10 -2 1 -11 26 -43 34 -43 8 0 97 68 116 89 8 10 23 20 33 24 15
6 17 13 11 43 -5 25 -3 35 4 30 6 -3 13 -2 17 4 3 5 2 10 -3 10 -5 0 -9 7 -9
15 0 8 6 15 13 15 7 0 15 6 18 13 4 8 5 7 5 -3 -3 -36 2 -50 16 -50 8 0 15 7
15 15 0 8 6 15 13 15 8 0 19 11 27 24 7 14 24 27 37 31 14 3 23 8 20 11 -3 3
3 14 14 25 15 15 18 29 14 66 -2 26 -1 43 3 37 4 -7 16 -14 27 -17 19 -5 19
-5 -2 -12 -26 -8 -29 -18 -9 -34 17 -14 15 -39 -5 -52 -10 -6 -7 -8 11 -5 14
3 33 5 43 5 9 1 17 8 17 16 0 11 28 15 160 17 154 3 160 2 161 -17 0 -11 3
-14 6 -7 3 8 28 12 74 12 44 0 68 -4 64 -10 -3 -5 -2 -10 4 -10 5 0 12 6 14
13 4 9 6 9 6 0 1 -17 48 -17 55 0 5 10 7 10 12 0 3 -7 23 -13 44 -13 21 0 40
-5 42 -12 3 -9 115 -13 449 -15 329 -2 483 -8 597 -20 83 -9 152 -20 152 -25
0 -4 54 -8 120 -8 67 0 120 -4 120 -9 0 -13 121 -20 488 -27 l312 -6 0 3661 0
3661 -5120 0 -5120 0 0 -3650z m5550 1471 c69 -11 157 -28 195 -37 39 -8 81
-18 95 -21 105 -21 335 -100 470 -160 146 -65 373 -183 415 -215 6 -5 48 -33
94 -63 95 -63 203 -146 275 -214 111 -106 272 -270 318 -326 27 -33 57 -69 66
-80 9 -11 37 -47 61 -80 24 -33 48 -61 53 -63 4 -2 8 -10 8 -17 0 -7 11 -27
25 -43 14 -17 25 -37 25 -46 0 -9 7 -19 15 -22 8 -4 15 -12 15 -19 0 -8 6 -20
13 -27 6 -7 21 -30 32 -50 11 -21 22 -38 25 -38 11 0 42 -100 36 -115 -3 -8
-2 -14 2 -12 12 4 52 -42 52 -60 0 -10 7 -31 15 -47 19 -36 19 -50 -1 -67 -14
-11 -15 -9 -8 26 5 30 4 36 -6 30 -8 -5 -18 -1 -26 9 -8 11 -14 13 -19 7 -9
-16 -34 11 -32 35 1 11 -3 18 -12 16 -9 -2 -12 4 -8 18 3 11 2 20 -2 20 -4 0
-13 18 -20 41 -7 23 -15 38 -19 34 -4 -4 -13 10 -20 32 l-12 38 4 -44 c3 -30
2 -40 -5 -30 -7 12 -10 12 -18 0 -6 -9 -11 -10 -15 -2 -4 6 -2 11 3 11 27 0 3
60 -29 73 -12 4 -11 6 3 6 21 1 23 19 2 27 -8 4 -15 17 -15 31 0 19 -4 23 -19
18 -15 -5 -21 0 -26 24 -3 16 -13 32 -20 35 -8 3 -12 12 -9 20 7 18 -14 59
-25 51 -12 -7 -22 21 -15 40 3 8 -6 26 -20 40 -14 14 -26 30 -26 35 0 5 -9 11
-20 15 -10 3 -29 22 -40 41 -12 18 -29 34 -38 34 -15 0 -15 -2 -2 -11 13 -9
13 -10 0 -6 -8 2 -14 10 -12 18 4 14 -18 60 -33 71 -5 4 -13 0 -17 -10 -5 -12
-7 -10 -7 11 -1 20 -8 30 -26 37 -14 5 -25 16 -25 24 0 8 -12 24 -27 36 l-28
22 -5 -29 -6 -28 -14 25 c-7 14 -13 37 -12 52 1 15 -3 30 -9 34 -8 5 -10 1 -7
-14 4 -13 0 -26 -10 -34 -11 -9 -14 -10 -9 -1 5 7 0 24 -9 38 -15 23 -15 25 0
19 9 -3 16 -1 16 5 0 17 -57 70 -84 77 -13 3 -27 12 -30 19 -3 8 -13 11 -24 8
-11 -2 -23 0 -26 6 -4 6 -17 9 -30 5 -14 -3 -27 1 -35 10 -12 14 -10 16 15 15
25 0 26 -1 9 -9 -13 -6 -15 -9 -5 -9 8 0 21 3 28 8 10 6 4 13 -21 25 -41 19
-61 21 -51 4 4 -7 3 -8 -5 -4 -6 4 -9 11 -6 16 3 5 -6 17 -20 26 -24 16 -37
43 -14 28 7 -4 10 -1 7 7 -6 18 -55 46 -64 36 -4 -4 1 -17 12 -28 19 -22 19
-22 -3 -10 -13 6 -23 18 -23 26 0 8 -4 15 -9 15 -5 0 -7 -10 -4 -22 3 -14 1
-18 -4 -12 -4 6 -26 21 -48 33 -22 12 -60 34 -85 49 -25 16 -65 39 -90 52 -68
37 -73 42 -58 52 9 6 6 7 -9 3 -14 -4 -40 3 -72 19 -62 32 -229 99 -316 127
-48 15 -63 24 -54 31 9 6 5 7 -12 3 -14 -4 -53 1 -85 10 -260 74 -516 105
-819 99 -277 -4 -494 -35 -710 -101 -138 -41 -213 -66 -240 -78 -16 -7 -41
-16 -55 -20 -24 -6 -96 -39 -214 -96 -33 -16 -65 -29 -72 -29 -7 0 -14 -4 -16
-8 -1 -4 -20 -18 -40 -30 -26 -16 -45 -21 -65 -17 -21 5 -24 4 -13 -4 13 -9
13 -12 0 -25 -25 -24 -110 -67 -120 -61 -5 3 -20 -3 -32 -14 -12 -12 -18 -21
-14 -21 4 0 -16 -19 -46 -42 -29 -23 -57 -48 -61 -55 -4 -7 -13 -13 -19 -13
-9 0 -9 3 0 12 13 13 16 28 5 28 -5 0 -21 -11 -37 -25 -16 -14 -32 -22 -35
-19 -3 4 0 9 7 11 6 3 12 9 12 14 0 16 -15 10 -28 -12 -11 -18 -11 -24 3 -39
14 -16 14 -19 -12 -35 -18 -12 -28 -14 -31 -7 -2 7 -8 12 -14 12 -5 0 -6 -9
-3 -21 5 -13 3 -19 -3 -15 -9 5 -24 -15 -26 -36 -1 -4 -10 -14 -21 -22 -19
-13 -22 -12 -32 10 -10 21 -9 23 7 14 10 -6 25 -10 32 -9 10 0 10 2 1 6 -10 3
-9 8 2 20 8 8 15 22 15 30 0 15 -2 15 -17 1 -10 -9 -33 -23 -50 -32 -18 -9
-33 -21 -33 -27 0 -6 -10 -24 -21 -41 -18 -25 -19 -32 -8 -39 9 -5 15 -4 17 4
11 39 14 42 22 22 9 -26 -36 -66 -52 -44 -7 10 -8 8 -3 -8 5 -17 -3 -30 -34
-59 -23 -20 -41 -42 -41 -50 0 -7 -4 -16 -10 -19 -7 -4 -7 3 0 20 6 15 10 34
9 43 0 13 -2 14 -6 3 -7 -18 -53 -61 -64 -61 -5 0 -12 -12 -15 -27 -9 -38 -34
-64 -54 -58 -14 4 -16 1 -12 -21 3 -19 1 -25 -7 -20 -6 4 -11 4 -11 -1 0 -4
-13 -14 -30 -21 -28 -13 -41 -32 -22 -32 5 0 7 -13 4 -30 -5 -38 -19 -39 -25
-2 -4 25 -4 25 -3 -3 1 -25 5 -30 24 -27 l23 2 -20 -29 c-12 -16 -21 -34 -21
-39 0 -6 -4 -13 -9 -17 -6 -3 -6 7 -1 27 12 39 7 44 -28 32 -22 -8 -26 -15
-24 -37 4 -28 -6 -35 -25 -16 -9 9 -16 -3 -28 -45 -9 -31 -23 -63 -32 -71 -13
-14 -17 -11 -40 22 -22 32 -23 39 -11 61 l13 24 6 -23 c5 -24 5 -24 11 4 3 16
1 27 -6 27 -6 0 -4 6 5 13 9 7 23 27 33 45 17 33 32 41 39 20 2 -7 2 -1 0 15
-3 20 0 29 14 34 10 3 29 15 43 26 24 19 24 19 2 12 l-22 -6 20 33 c11 18 23
41 26 51 4 9 9 17 13 17 3 0 17 18 31 40 14 22 28 40 32 40 5 0 8 5 8 11 0 12
26 40 228 244 151 153 199 196 252 230 19 13 45 31 58 41 86 72 222 158 368
235 50 26 100 52 110 57 70 37 367 151 452 173 17 5 49 13 70 19 158 42 406
87 517 94 33 2 175 2 315 0 199 -2 282 -7 380 -23z m-110 -286 c295 -39 558
-115 800 -232 52 -25 111 -56 130 -69 35 -24 35 -33 -1 -13 -31 16 -110 38
-104 29 7 -12 -62 0 -100 16 -16 7 -25 13 -20 14 16 1 -18 20 -35 19 -10 0 -8
-3 5 -9 15 -7 10 -8 -20 -6 -22 2 -49 8 -60 14 -11 5 -38 13 -60 17 -22 4 -65
14 -95 22 -94 25 -131 32 -260 49 -69 9 -154 20 -190 25 -92 12 -639 13 -686
0 -22 -5 -92 -15 -156 -20 -64 -6 -125 -14 -135 -19 -19 -11 -147 -32 -188
-32 -14 0 -25 -4 -25 -9 0 -5 -15 -11 -32 -14 -18 -3 -50 -8 -72 -11 -21 -4
-43 -2 -50 3 -7 6 -20 4 -36 -4 -16 -9 -19 -14 -10 -15 9 0 20 4 25 9 6 6 15
4 22 -4 10 -11 4 -13 -34 -10 -26 2 -54 -1 -62 -5 -23 -12 -81 -30 -81 -25 0
11 184 96 300 139 217 82 503 141 770 160 91 6 348 -5 460 -19z m-1540 -290
c0 -2 -10 -10 -22 -16 -21 -11 -22 -11 -9 4 13 16 31 23 31 12z m2877 -51 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m163 -114 c0 -5 -4 -10 -10
-10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m25 -30 c3 -5 1 -10
-4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m50 -26 c-9 -9 -19
-13 -23 -10 -3 4 0 11 8 16 24 15 33 11 15 -6z m30 -20 c-9 -9 -18 -14 -21
-11 -9 9 6 27 22 27 13 0 13 -2 -1 -16z m-2393 -173 l33 -29 1 -344 c1 -189
-1 -712 -5 -1163 -5 -556 -8 -690 -9 -417 -1 275 -5 402 -13 402 -7 0 -9 -40
-7 -120 2 -97 0 -119 -10 -115 -8 3 -187 5 -399 5 -213 0 -384 2 -381 5 6 6
253 12 576 14 127 1 202 5 202 11 0 6 -135 10 -384 10 -246 0 -387 4 -391 10
-4 7 126 10 383 10 l389 0 1 35 1 35 -82 2 c-45 1 -156 0 -247 -1 -181 -4
-466 8 -453 18 4 3 166 4 360 1 193 -3 349 -1 346 3 -4 7 28 3 65 -9 7 -2 12
5 12 16 0 20 -9 20 -390 20 -253 0 -390 4 -390 10 0 6 137 10 390 10 305 0
390 3 390 13 0 9 -84 11 -394 9 -221 -1 -397 2 -400 7 -11 17 188 23 490 16
277 -7 304 -6 304 9 0 14 -36 16 -394 16 -253 0 -397 4 -401 10 -7 11 31 12
512 14 219 1 283 4 283 14 0 9 -87 12 -400 12 -257 0 -400 4 -400 10 0 5 8 9
18 8 82 -7 782 4 782 12 0 7 -140 10 -400 10 -260 0 -400 4 -400 10 0 7 140
10 400 10 349 0 400 2 400 15 0 17 10 16 -260 14 -102 0 -232 -1 -290 0 -58 0
-133 1 -167 1 -35 0 -63 4 -63 10 0 6 137 10 391 10 308 0 390 3 386 13 -3 9
-76 11 -333 9 -332 -3 -449 2 -438 20 3 5 16 8 27 7 90 -7 747 3 747 11 0 7
-140 10 -400 10 -260 0 -400 4 -400 10 0 7 140 10 400 10 313 0 400 3 400 13
0 9 -84 12 -388 12 -251 0 -387 4 -387 10 0 6 138 11 388 13 246 1 387 6 387
12 0 6 -138 10 -384 10 -211 0 -391 3 -399 6 -11 4 -17 -2 -20 -23 -2 -15 -5
99 -6 254 l-1 281 33 8 c17 4 62 8 99 8 36 1 70 4 74 9 4 4 -34 7 -85 7 -73 0
-93 3 -97 15 -4 8 0 23 7 32 12 15 11 16 -8 11 -21 -6 -23 -3 -23 32 0 34 2
38 23 34 18 -4 19 -3 4 4 -10 4 -18 11 -18 15 4 37 -1 87 -8 83 -5 -4 -10
-333 -10 -768 -1 -419 -4 -764 -7 -767 -2 -2 -4 419 -4 937 0 1035 -1 1009 58
1031 16 5 181 10 389 10 l363 1 32 -29z m2592 -32 c-2 -4 0 -10 6 -14 5 -3 10
-10 10 -16 0 -5 -8 -1 -18 9 -10 9 -16 25 -14 35 4 14 7 15 13 6 4 -7 6 -16 3
-20z m-4308 -90 c3 -6 0 -17 -7 -25 -12 -11 -14 -9 -14 11 0 26 9 32 21 14z
m4421 -46 c-3 -3 -10 -2 -16 2 -7 4 -7 10 2 20 10 11 13 11 15 -2 2 -8 1 -17
-1 -20z m-4467 -26 c0 -10 -50 -60 -55 -56 -3 3 6 18 19 32 23 24 36 33 36 24z
m-60 -82 c0 -2 -9 -3 -19 -2 -11 0 -18 5 -15 9 4 6 34 0 34 -7z m4610 -5 c0
-5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-4657
-45 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-91 -147 c-7 -7
-12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z m4898 -42 c0 -6 -7 -2
-15 8 -8 11 -15 25 -15 30 0 6 7 2 15 -8 8 -11 15 -25 15 -30z m-5056 -42 c7
-27 36 -63 36 -45 0 6 5 11 12 11 9 0 9 -3 0 -12 -15 -15 -16 -38 -2 -38 6 0
10 6 10 14 0 7 7 19 15 26 21 17 19 8 -7 -36 l-22 -37 -9 26 c-10 32 -27 35
-34 7 -3 -11 -9 -20 -14 -20 -5 0 -6 -6 -3 -13 7 -18 -22 -41 -41 -33 -17 6
-20 41 -5 51 6 3 10 15 10 26 0 12 -4 17 -11 14 -6 -4 -8 -14 -4 -24 5 -13 4
-14 -7 -3 -10 10 -10 17 2 36 8 12 24 36 35 53 22 35 30 35 39 -3z m2594 -573
c1 -408 -1 -557 -9 -568 -9 -10 -38 -13 -123 -11 l-111 3 -3 559 c-2 441 0
561 10 568 7 4 63 7 123 6 l110 -3 3 -554z m440 547 c9 -9 12 -74 12 -229 0
-124 4 -220 9 -224 5 -3 85 95 177 217 92 123 175 228 183 235 25 19 255 17
271 -2 16 -20 11 -27 -200 -300 -96 -124 -176 -231 -178 -238 -3 -12 10 -30
88 -127 311 -387 333 -418 310 -445 -10 -12 -37 -15 -136 -15 l-123 0 -75 93
c-41 50 -110 136 -153 189 -43 53 -89 111 -103 129 -65 85 -59 99 -60 -153 0
-194 -2 -229 -16 -243 -13 -13 -36 -15 -128 -13 l-111 3 -3 554 c-1 401 1 558
9 567 15 18 209 20 227 2z m1441 -5 c27 -23 158 -373 343 -915 51 -148 59
-180 48 -193 -11 -13 -33 -15 -123 -13 l-109 3 -37 105 -37 105 -216 3 -215 2
-11 -27 c-6 -16 -20 -59 -32 -98 -12 -38 -29 -76 -38 -82 -24 -20 -216 -18
-232 2 -15 18 4 79 163 525 168 471 200 553 223 577 21 21 32 23 137 23 95 0
119 -3 136 -17z m-3149 -63 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10
10 10 6 0 10 -4 10 -10z m-1410 -40 c0 -20 -5 -30 -15 -30 -9 0 -18 -7 -21
-15 -4 -8 -10 -15 -15 -15 -5 0 1 20 13 45 26 52 38 57 38 15z m5280 -70 c0
-5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m27
-22 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-5327 -132 c0 -3
-4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m5515 -66
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-5518
-40 c-6 -16 -13 -28 -15 -26 -6 6 10 56 18 56 5 0 3 -13 -3 -30z m5448 -90 c3
-5 3 -15 -1 -21 -6 -11 -23 6 -24 24 0 10 18 9 25 -3z m-5501 -68 c-4 -12 -10
-22 -15 -22 -12 0 -11 17 2 25 6 4 8 14 4 24 -4 11 -3 13 4 6 6 -6 8 -20 5
-33z m5523 -29 c0 -16 3 -44 8 -63 4 -19 5 -32 1 -28 -4 3 -13 31 -20 62 -11
44 -11 56 -1 56 7 0 12 -12 12 -27z m143 -112 c0 -6 -4 -13 -10 -16 -5 -3 -10
1 -10 9 0 9 5 16 10 16 6 0 10 -4 10 -9z m-5713 -43 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z m-25 -127 c-4 -10 -8 -8 -13 7 -5 12 -5 30 -2 40
6 14 8 13 13 -8 4 -14 4 -31 2 -39z m5645 -48 c-3 -10 -5 -4 -5 12 0 17 2 24
5 18 2 -7 2 -21 0 -30z m-5670 -125 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2
-19 0 -25z m2347 -17 c-8 -8 -555 -17 -664 -11 l-45 3 45 7 c69 11 676 12 664
1z m-721 -8 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m4074 -85
c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m-5710 -40 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m2373 -7 c0 -8 -117 -11 -386 -11
-212 0 -383 4 -380 8 8 13 766 16 766 3z m3337 -43 c-3 -8 -6 -5 -6 6 -1 11 2
17 5 13 3 -3 4 -12 1 -19z m-4072 -8 c-3 -5 -12 -10 -20 -10 -8 0 -17 5 -20
10 -4 6 5 10 20 10 15 0 24 -4 20 -10z m680 -1 c-39 -8 -645 -2 -654 7 -2 2
153 3 345 3 222 -1 334 -4 309 -10z m747 -37 c60 -30 114 -90 129 -144 6 -24
12 -109 13 -189 1 -143 1 -146 -29 -204 -34 -66 -93 -118 -153 -135 -20 -5
-117 -10 -214 -10 l-178 0 0 348 c0 192 3 352 8 356 4 4 90 6 192 4 169 -3
189 -5 232 -26z m633 11 c7 -17 58 -168 175 -511 28 -84 49 -159 46 -167 -4
-11 -23 -15 -69 -15 l-64 0 -25 68 -25 67 -133 0 -133 0 -21 -65 -21 -65 -67
-3 c-66 -3 -68 -2 -68 21 0 13 4 37 9 53 6 16 44 137 87 269 42 132 88 268
101 303 l25 62 88 0 c74 0 89 -3 95 -17z m773 -50 l3 -62 -98 -3 -98 -3 -3
-288 -2 -288 -73 3 -72 3 -3 288 -2 287 -104 0 c-118 0 -114 -3 -108 82 l4 48
276 -2 277 -3 3 -62z m410 54 c12 -14 76 -184 97 -257 7 -25 41 -124 74 -220
34 -96 61 -184 61 -197 0 -22 -4 -23 -68 -23 l-67 0 -23 64 c-27 74 -32 76
-166 76 -119 0 -122 -2 -146 -76 l-22 -64 -69 0 c-59 0 -69 2 -69 18 0 17 213
662 225 682 9 15 160 13 173 -3z m-2508 -17 c0 -6 -137 -10 -390 -10 -253 0
-390 4 -390 10 0 6 137 10 390 10 253 0 390 -4 390 -10z m-32 -45 c-9 -9 -728
-13 -734 -4 -3 5 159 9 367 9 205 0 370 -2 367 -5z m0 -50 c3 -3 -170 -4 -384
-3 -297 2 -350 4 -224 8 185 7 600 4 608 -5z m-53 -45 c-47 -12 -697 -12 -690
0 4 6 135 10 363 9 196 -1 344 -5 327 -9z m82 4 c-3 -3 -12 -4 -19 -1 -8 3 -5
6 6 6 11 1 17 -2 13 -5z m3340 -51 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2
-21 0 -30z m-5710 -5 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m2373 11 c0 -5 -171 -10 -380 -11 -209 -2 -380 0 -380 4 0 4 145 9 323 10 177
2 348 4 380 4 31 1 57 -2 57 -7z m-605 -53 c11 -2 -18 -4 -65 -4 -47 -1 -80 2
-73 6 10 6 92 5 138 -2z m571 2 c3 -4 -114 -8 -260 -8 -185 0 -266 3 -266 11
0 13 518 10 526 -3z m0 -45 c-7 -8 -737 -5 -745 2 -2 3 166 5 374 5 208 0 375
-3 371 -7z m-621 -43 c-2 -3 -27 -6 -57 -7 -37 -1 -47 1 -33 7 21 9 95 9 90 0z
m620 0 c12 -5 -109 -9 -292 -9 -203 -1 -313 3 -313 9 0 12 576 12 605 0z
m-1277 -31 c17 -6 34 -18 38 -27 4 -9 10 -72 14 -138 8 -138 26 -186 91 -250
34 -33 43 -37 106 -41 52 -4 77 -1 99 11 40 21 74 52 74 65 0 7 7 14 15 17 8
4 15 15 15 25 0 27 20 24 21 -3 1 -21 2 -20 14 7 l14 30 1 -42 c0 -25 -5 -43
-11 -43 -6 0 -9 -7 -6 -14 4 -10 -7 -23 -29 -36 -33 -21 -42 -34 -26 -43 4 -2
1 -2 -6 -1 -23 6 -72 -8 -72 -21 0 -6 -10 -16 -21 -21 -27 -12 -174 7 -209 26
-14 8 -29 14 -33 15 -12 0 -27 28 -27 53 0 12 -4 22 -9 22 -5 0 -7 10 -4 23 4
18 3 19 -6 7 -8 -12 -11 -8 -11 18 0 22 -5 32 -15 32 -8 0 -16 8 -16 18 -4 38
-5 48 -13 72 -4 14 -2 38 3 53 6 15 9 28 8 29 -1 1 -85 5 -187 8 l-185 6 181
2 181 2 1 45 c1 40 -2 47 -24 55 -14 6 -91 11 -172 12 -147 2 -147 2 -47 8 83
5 60 7 -130 11 -126 2 -261 3 -298 1 -44 -1 -66 1 -62 8 9 14 702 14 743 -1z
m992 -17 c0 -4 -71 -6 -157 -4 -226 4 -237 9 -25 11 100 0 182 -2 182 -7z
m-1485 -12 c47 -7 45 -7 -32 -9 -50 0 -83 3 -83 9 0 11 43 12 115 0z m-279
-26 c-4 -9 -9 -15 -11 -12 -3 3 -3 13 1 22 4 9 9 15 11 12 3 -3 3 -13 -1 -22z
m1727 -1 c-24 -2 -62 -2 -85 0 -24 2 -5 4 42 4 47 0 66 -2 43 -4z m-1984 -62
c4 -28 4 -51 0 -51 -5 0 -9 15 -9 33 0 17 -3 43 -7 57 -3 14 -3 22 1 19 4 -4
10 -30 15 -58z m2239 52 c-27 -2 -69 -2 -95 0 -27 2 -5 3 47 3 52 0 74 -1 48
-3z m-1315 -10 c-35 -2 -91 -2 -125 0 -35 2 -7 3 62 3 69 0 97 -1 63 -3z
m1162 -28 l180 -13 -205 5 c-113 3 -234 9 -270 13 l-65 7 90 1 c50 0 171 -5
270 -13z m-1105 -11 c0 -2 -7 -4 -15 -4 -8 0 -15 4 -15 10 0 5 7 7 15 4 8 -4
15 -8 15 -10z m667 -20 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m383 -5 c80 -5 148 -13 152 -17 4 -4 -43 -4 -105 1 -62 4 -173 11 -247 16
-134 8 -134 8 -40 9 52 1 160 -3 240 -9z m3620 -9 c0 -11 -4 -20 -9 -20 -5 0
-7 9 -4 20 3 11 7 20 9 20 2 0 4 -9 4 -20z m-3741 -25 c2 -3 -26 -5 -62 -5
-37 0 -67 4 -67 9 0 9 119 5 129 -4z m-1299 -4 c31 -6 -6 -8 -115 -8 -131 1
-144 2 -75 7 125 9 141 9 190 1z m285 4 c-24 -8 -235 -12 -235 -4 0 5 55 9
123 8 67 0 118 -2 112 -4z m78 -2 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0
24 -2 18 -5z m1102 -13 c29 -7 28 -8 -10 -8 -22 0 -60 3 -85 7 l-45 8 55 1
c30 0 69 -4 85 -8z m-124 -26 c99 -14 157 -31 74 -21 -22 2 -107 12 -190 21
-82 9 -157 18 -165 21 -33 10 185 -6 281 -21z m-968 9 c3 -5 -72 -8 -167 -9
-133 -1 -151 0 -81 6 136 10 243 11 248 3z m1190 0 c-7 -2 -21 -2 -30 0 -10 3
-4 5 12 5 17 0 24 -2 18 -5z m117 -3 c12 -8 10 -10 -10 -9 -14 1 -36 5 -50 9
-23 7 -22 8 10 9 19 0 42 -4 50 -9z m-1697 -17 c-18 -2 -48 -2 -65 0 -18 2 -4
4 32 4 36 0 50 -2 33 -4z m1120 0 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
-2 13 -5z m-755 -10 c-15 -2 -42 -2 -60 0 -18 2 -6 4 27 4 33 0 48 -2 33 -4z
m845 0 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-998 -13
c-27 -5 -72 -8 -100 -8 -47 1 -48 1 -15 8 19 4 64 7 100 7 l65 0 -50 -7z
m1090 0 c17 -7 16 -9 -10 -9 -16 0 -37 4 -45 9 -12 8 -10 10 10 9 14 0 34 -4
45 -9z m233 3 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m177
-18 c6 -3 -8 -3 -30 0 -22 3 -60 5 -85 6 -31 0 -39 3 -26 8 18 7 118 -3 141
-14z m-2278 -17 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m1480 0
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-894 15 c-7 -2 -19 -2
-25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m242 -13 c-71 -10 -148 -18 -170 -18
-36 1 -34 1 15 9 126 19 188 26 235 27 30 0 -2 -8 -80 -18z m672 -2 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m162 6 c10 -9 -45 -3 -59 6 -11 7
-5 8 20 4 19 -4 37 -8 39 -10z m140 0 c9 -8 -45 -2 -64 6 -14 7 -8 8 20 3 22
-3 42 -7 44 -9z m201 6 c19 -12 -42 -12 -80 0 -21 7 -17 8 20 9 25 0 52 -4 60
-9z m-1613 -6 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m71 -1
c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m1350 -32 c104 -27
144 -41 113 -41 -11 0 -111 26 -221 58 -79 23 3 10 108 -17z m90 18 c54 -13
84 -34 37 -26 -16 3 -52 12 -80 20 -60 18 -26 22 43 6z m169 5 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-1172 -14 c-67 -13 -150 -22 -144
-15 7 7 113 23 154 23 24 0 22 -2 -10 -8z m1345 -11 c25 -14 -39 -10 -95 6
l-50 14 65 -6 c36 -3 72 -9 80 -14z m-1657 4 c-7 -2 -19 -2 -25 0 -7 3 -2 5
12 5 14 0 19 -2 13 -5z m1097 -3 c12 -8 11 -10 -5 -9 -11 1 -31 5 -45 9 -24 8
-24 8 5 9 17 0 37 -4 45 -9z m-1670 -19 c0 -11 3 -28 6 -38 6 -16 5 -16 -9 2
-18 22 -22 55 -7 55 6 0 10 -9 10 -19z m933 12 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m4633 -48 c-8 -28 -21 -68 -30 -90 l-16 -40 6 40 c4
22 10 44 15 50 5 5 9 17 9 26 0 22 19 73 25 67 2 -2 -2 -26 -9 -53z m-4856 35
c-14 -4 -36 -8 -50 -8 -23 -1 -23 0 -5 8 11 5 34 8 50 8 29 0 29 0 5 -8z m150
0 c0 -5 -6 -10 -14 -10 -7 0 -29 -2 -47 -5 l-34 -5 35 14 c42 18 60 19 60 6z
m775 0 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6 4 10 9 10 6 0 13 -4 16 -10z
m140 -10 c30 -14 35 -19 18 -19 -12 -1 -25 3 -28 9 -3 5 -20 14 -38 19 -19 5
-24 9 -12 9 11 0 38 -8 60 -18z m-1160 0 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3
10 19 12 23 12 15 0z m1702 -12 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m-1383 3 c4 -5 -3 -7 -14 -4 -10 3 -67 -9 -125 -27 -58 -18 -109 -30
-112 -27 -3 3 21 13 53 22 33 9 79 23 104 30 54 16 87 18 94 6z m761 -1 c13
-6 15 -9 5 -9 -8 0 -22 4 -30 9 -18 12 -2 12 25 0z m455 0 c10 -6 2 -7 -25 -3
-49 7 -58 13 -19 13 16 0 36 -5 44 -10z m-1410 -10 c-8 -5 -28 -9 -45 -9 l-30
1 30 8 c17 4 37 8 45 9 13 1 13 0 0 -9z m925 -10 c3 -6 -1 -7 -9 -4 -18 7 -21
14 -7 14 6 0 13 -4 16 -10z m85 0 c8 -5 11 -10 5 -10 -5 0 -17 5 -25 10 -8 5
-10 10 -5 10 6 0 17 -5 25 -10z m164 -21 c-5 -8 -54 12 -54 23 0 3 13 1 29 -5
17 -6 28 -14 25 -18z m111 21 c8 -13 -15 -13 -35 0 -12 8 -11 10 7 10 12 0 25
-4 28 -10z m192 4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-1304 -11 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-303 -7 c0
-2 -9 -6 -20 -9 -11 -3 -18 -1 -14 4 5 9 34 13 34 5z m257 -2 c-10 -10 -177
-64 -196 -63 -9 0 21 12 66 27 45 15 85 31 89 35 4 4 16 7 27 7 11 0 17 -3 14
-6z m768 -4 c3 -5 -3 -10 -15 -10 -12 0 -18 5 -15 10 3 6 10 10 15 10 5 0 12
-4 15 -10z m72 4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m98
-4 c19 -8 19 -9 -2 -9 -12 -1 -25 4 -28 9 -7 12 2 12 30 0z m-1790 -10 c3 -5
1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m900 -5 c-16
-8 -39 -14 -50 -14 -13 0 -8 5 15 14 46 18 74 17 35 0z m852 -1 c47 -21 65
-28 127 -50 27 -10 44 -20 37 -22 -7 -2 -34 5 -61 17 -27 12 -53 21 -58 21 -6
0 -30 11 -53 25 -51 29 -47 32 8 9z m366 9 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12
5 17 0 24 -2 18 -5z m-223 -26 c19 -6 28 -12 20 -14 -17 -4 -90 23 -90 33 0 3
8 3 18 -1 9 -4 33 -12 52 -18z m100 13 c12 -8 12 -10 -5 -10 -11 0 -27 5 -35
10 -12 8 -12 10 5 10 11 0 27 -5 35 -10z m-313 -6 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m-862 -14 c-3 -5 -10 -10 -16 -10 -5 0 -29 -9 -54
-21 -24 -11 -50 -19 -57 -17 -7 3 4 10 25 17 22 7 51 19 65 27 32 16 46 18 37
4z m85 0 c0 -5 -3 -10 -7 -10 -5 0 -19 -3 -33 -6 l-25 -6 25 15 c31 18 40 20
40 7z m744 2 c2 -4 -4 -9 -15 -9 -10 -1 -19 2 -19 8 0 11 27 12 34 1z m81 -2
c3 -5 15 -10 26 -10 10 0 19 -4 19 -10 0 -14 -26 -12 -42 3 -7 8 -20 16 -28
20 -12 4 -12 6 2 6 9 1 20 -3 23 -9z m335 0 c12 -8 12 -10 -5 -10 -11 0 -27 5
-35 10 -12 8 -12 10 5 10 11 0 27 -5 35 -10z m-1493 -6 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m1388 -14 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7
14 6 0 13 -4 16 -10z m-1125 -4 c0 -7 -107 -56 -121 -55 -8 0 13 13 46 29 59
28 75 34 75 26z m90 -6 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10
6 0 11 -4 11 -10z m680 6 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10
11 6 0 10 -2 10 -4z m188 -44 c41 -20 71 -37 66 -39 -5 -1 -49 18 -99 42 -104
53 -79 50 33 -3z m-1771 16 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m440 16 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m148 -4
c-3 -5 -14 -10 -23 -10 -15 0 -15 2 -2 10 20 13 33 13 25 0z m280 0 c3 -5 0
-10 -9 -10 -8 0 -23 -3 -33 -6 -16 -5 -16 -4 1 10 23 19 32 20 41 6z m790 -11
c17 -10 37 -21 45 -24 28 -11 115 -58 125 -68 13 -12 10 -11 -112 48 -56 28
-102 53 -103 58 0 11 12 7 45 -14z m171 -6 c30 -14 52 -28 50 -31 -5 -5 -116
46 -116 53 0 9 11 5 66 -22z m293 -20 c2 -2 2 -5 -1 -8 -6 -6 -98 31 -98 39 0
4 87 -23 99 -31z m-533 18 c-4 -5 -1 -12 4 -14 6 -3 5 -4 -2 -3 -15 3 -23 26
-8 26 6 0 9 -4 6 -9z m1404 -10 c5 -11 10 -32 10 -46 0 -14 -5 -35 -10 -46
-10 -17 -23 -19 -160 -19 -170 0 -180 -4 -180 -73 0 -73 24 -87 151 -87 120 0
168 -21 200 -86 18 -39 21 -58 17 -132 -5 -103 -22 -139 -82 -174 -38 -21 -54
-23 -221 -26 -162 -3 -180 -2 -192 14 -16 22 -17 86 -1 102 8 8 59 12 164 12
175 0 184 4 184 74 0 73 -11 79 -149 86 -99 5 -126 10 -148 26 -51 39 -64 66
-70 150 -8 124 19 193 89 227 27 13 67 17 210 17 165 0 178 -1 188 -19z m300
0 c6 -12 10 -115 10 -266 l0 -246 25 -24 c21 -22 33 -25 94 -25 59 0 74 4 98
24 l28 24 5 264 5 263 71 3 71 3 7 -32 c10 -50 7 -438 -4 -503 -11 -67 -45
-118 -101 -151 -50 -30 -257 -35 -331 -9 -62 23 -101 71 -117 145 -12 54 -15
531 -4 542 3 4 35 7 69 7 52 0 65 -3 74 -19z m1003 -5 c60 -30 81 -69 85 -157
4 -79 -12 -134 -44 -146 -20 -8 -17 -31 6 -38 23 -7 55 -58 65 -102 12 -58
-12 -140 -54 -182 -52 -52 -97 -61 -310 -61 -165 0 -181 2 -190 18 -12 23 -9
661 3 681 6 10 52 12 205 9 167 -3 202 -6 234 -22z m699 -1 c8 -17 8 -37 2
-63 l-9 -37 -158 -5 c-142 -4 -160 -7 -173 -24 -18 -26 -18 -60 1 -96 9 -17
17 -30 18 -31 1 0 55 -4 119 -9 138 -10 175 -26 207 -94 24 -49 28 -145 9
-208 -14 -47 -63 -93 -115 -107 -21 -6 -108 -11 -194 -11 -179 0 -182 1 -177
77 l3 48 155 3 c179 3 190 8 190 78 0 72 -18 81 -170 86 -79 3 -101 8 -127 26
-57 41 -67 67 -68 177 0 121 16 158 85 193 41 20 58 22 217 22 l173 0 12 -25z
m-4208 1 c-10 -8 -21 -12 -24 -10 -5 6 21 24 34 24 6 0 1 -6 -10 -14z m72 -1
c-20 -15 -36 -19 -36 -10 0 5 38 23 50 24 3 0 -4 -6 -14 -14z m804 -11 c22
-15 40 -28 40 -31 0 -5 -51 22 -75 41 -33 25 -8 18 35 -10z m287 20 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-385 -11 c2 -5 20 -21 41 -37
21 -15 36 -30 34 -33 -3 -2 -15 4 -27 14 -61 49 -74 62 -63 63 6 0 13 -3 15
-7z m-906 -18 c-11 -8 -29 -15 -40 -15 -17 1 -15 4 9 15 40 18 55 18 31 0z
m4851 -15 c-6 -16 -13 -28 -15 -26 -6 6 10 56 18 56 5 0 3 -13 -3 -30z m-4702
10 c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z
m65 0 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m806 -31 c8 -13 -21 1 -51 26 -19 15 -18 15 12 1 17 -9 35 -21 39 -27z m275
20 c23 -11 39 -23 36 -26 -6 -5 -97 33 -97 41 0 11 21 6 61 -15z m-1424 5 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m553 -4 c0 -5 -4 -10 -10
-10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m540 -57 c0 -2 -14 5
-31 17 -16 12 -33 19 -36 16 -4 -4 4 -14 18 -23 38 -27 189 -176 189 -187 0
-6 -40 30 -90 79 -49 49 -93 85 -97 81 -4 -4 0 -14 10 -21 12 -9 17 -20 13
-33 -5 -13 8 -35 41 -75 108 -126 125 -148 121 -153 -3 -2 -26 21 -52 53 -97
120 -174 204 -222 241 -33 26 -13 19 29 -11 30 -21 47 -17 28 7 -9 11 -10 20
-1 36 6 11 8 26 3 33 -4 6 12 -3 35 -21 23 -19 42 -36 42 -39z m-810 35 c-19
-12 -38 -27 -42 -32 -4 -6 -10 -8 -13 -4 -7 7 63 57 80 57 6 0 -6 -9 -25 -21z
m70 7 c-7 -8 -17 -15 -23 -15 -6 0 -2 7 9 15 25 19 30 19 14 0z m-203 -1 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m613 -4 c12 -8 9 -10 -13
-10 -16 0 -26 4 -22 10 8 12 16 12 35 0z m506 -28 c24 -15 44 -30 44 -34 0 -4
-21 5 -47 21 -27 16 -57 34 -68 40 -19 11 -18 12 3 6 13 -4 44 -19 68 -33z
m-579 22 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m4254 -24 c5
0 9 -4 9 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -5 -15 -12 0 -6 -3 -9 -6 -5 -3 3
-2 21 2 39 5 21 9 27 12 16 2 -10 8 -18 13 -18z m-4841 15 c0 -6 -76 -45 -87
-45 -9 0 68 48 80 49 4 1 7 -1 7 -4z m1079 -58 c1 -5 -12 2 -28 15 -17 13 -30
27 -30 31 -1 5 12 -2 28 -15 17 -13 30 -27 30 -31z m-1655 -7 l7 -25 -15 25
c-9 14 -15 32 -15 40 0 13 1 13 8 0 5 -8 12 -26 15 -40z m610 35 c-10 -8 -23
-14 -29 -14 -5 0 -1 6 9 14 11 8 24 15 30 15 5 0 1 -7 -10 -15z m1087 -2 c16
-10 29 -21 29 -26 0 -7 -37 14 -69 40 -14 10 16 0 40 -14z m-1011 -3 c0 -5 -4
-10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m1049 -133
c5 -13 -33 19 -103 87 -60 57 -60 57 19 -10 44 -37 82 -72 84 -77z m412 120
c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-1411 9 c0 -2 -25
-20 -55 -40 -30 -20 -57 -41 -60 -46 -3 -6 -11 -10 -16 -10 -15 0 16 30 70 67
43 30 61 38 61 29z m33 -11 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13
8 -4z m-208 -5 c-10 -16 -45 -32 -45 -20 0 5 7 10 15 10 8 0 15 5 15 10 0 6 5
10 11 10 5 0 7 -4 4 -10z m275 -10 c0 -5 -5 -10 -10 -10 -6 0 -19 -15 -30 -32
-11 -19 -20 -26 -20 -17 0 9 9 24 20 34 11 10 17 22 14 26 -3 5 2 9 10 9 9 0
16 -4 16 -10z m1080 -16 c0 -2 -9 0 -20 6 -11 6 -20 13 -20 16 0 2 9 0 20 -6
11 -6 20 -13 20 -16z m-1295 6 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9 10 3 6
13 10 21 10 8 0 12 -4 9 -10z m109 -11 c-10 -12 -32 -30 -49 -41 -20 -13 -15
-6 14 21 47 44 67 55 35 20z m35 -14 c-18 -19 -36 -35 -40 -35 -5 0 6 16 24
35 17 19 35 35 40 35 4 0 -7 -16 -24 -35z m677 27 c-5 -8 41 -78 71 -110 7 -7
13 -17 13 -21 0 -4 11 -21 25 -37 14 -16 25 -35 25 -43 0 -8 -18 12 -40 45
-22 32 -51 73 -65 89 -23 26 -25 27 -20 8 11 -39 -9 -25 -33 23 -13 25 -19 43
-13 40 5 -4 12 -2 16 4 3 5 11 10 16 10 6 0 8 -4 5 -8z m272 -19 c20 -16 39
-31 40 -36 2 -4 17 -14 34 -23 16 -8 28 -18 25 -21 -6 -5 -75 40 -122 81 -40
34 -24 33 23 -1z m47 17 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10
3 0 8 -4 11 -10z m-931 -37 c-16 -21 -36 -45 -45 -54 -9 -9 -19 -23 -21 -30
-3 -8 -8 -12 -11 -8 -4 3 16 33 44 67 54 67 80 86 33 25z m564 4 c12 -18 22
-36 22 -39 0 -3 18 -36 41 -73 22 -37 43 -74 46 -83 4 -10 15 -28 25 -41 18
-24 24 -46 10 -37 -11 7 -92 143 -92 155 0 5 -6 16 -13 23 -7 7 -21 29 -30 48
-10 19 -25 45 -33 58 -9 12 -13 22 -8 22 5 0 19 -15 32 -33z m90 12 c19 -30 8
-34 -12 -4 -9 14 -13 25 -9 25 5 0 14 -9 21 -21z m362 11 c0 -5 -4 -10 -10
-10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m300 6 c0 -3 -4 -8
-10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-794 -53 c-8 -8
-12 -3 -21 27 l-7 25 17 -23 c9 -13 14 -26 11 -29z m-492 10 c-10 -16 -24 -34
-31 -41 -7 -7 -25 -34 -39 -58 -15 -25 -28 -43 -31 -40 -7 7 16 46 65 109 47
60 67 76 36 30z m813 -99 c-6 -7 -96 85 -109 111 -5 11 18 -8 52 -43 34 -35
60 -66 57 -68z m218 106 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4
10 5 0 13 -4 16 -10z m-1435 -10 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3 10 19
12 20 12 20 0z m-426 -15 c3 -8 1 -15 -4 -15 -6 0 -10 7 -10 15 0 8 2 15 4 15
2 0 6 -7 10 -15z m726 -10 c-7 -9 -15 -13 -17 -11 -6 6 20 36 26 30 2 -2 -2
-10 -9 -19z m134 11 c-3 -8 -13 -17 -22 -21 -13 -5 -13 -2 3 15 21 24 26 25
19 6z m1037 -3 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z
m3429 2 c0 -8 -4 -15 -10 -15 -5 0 -7 7 -4 15 4 8 8 15 10 15 2 0 4 -7 4 -15z
m-4860 -15 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5
-5 -10z m220 6 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m650
-56 c0 -8 -9 -1 -20 15 -11 17 -20 35 -20 40 1 16 40 -38 40 -55z m216 -14
c13 -15 24 -35 24 -44 0 -9 -14 4 -32 29 -18 24 -35 46 -38 49 -4 3 -10 14
-13 25 -6 16 -3 15 14 -5 11 -14 31 -38 45 -54z m284 64 c0 -5 -2 -10 -4 -10
-3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-823 -22 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m28 -43 c-4 -31 -10 -54 -12 -51 -3 3
-2 30 2 61 3 31 9 54 12 52 2 -3 1 -31 -2 -62z m32 3 c-2 -13 -4 -3 -4 22 0
25 2 35 4 23 2 -13 2 -33 0 -45z m33 22 c0 -22 -4 -40 -10 -40 -5 0 -10 18
-10 40 0 22 5 40 10 40 6 0 10 -18 10 -40z m27 -310 c0 -98 -1 -106 -7 -55 -4
33 -8 139 -7 235 l1 175 6 -120 c4 -66 7 -172 7 -235z m38 81 c8 -112 13 -206
11 -208 -9 -9 -37 332 -35 417 3 78 5 55 24 -209z m12 232 c-3 -10 -5 -4 -5
12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m52 10 c0 -25 -1 -26 -9 -8 -12 27 -12
35 0 35 6 0 10 -12 9 -27z m91 -75 c11 -26 20 -51 20 -56 0 -5 7 -23 16 -41 8
-17 14 -36 12 -42 -4 -13 -22 27 -67 149 -47 126 -38 121 19 -10z m42 70 c8
-18 34 -67 56 -108 23 -41 42 -82 42 -90 0 -8 -15 14 -33 50 -19 36 -48 91
-66 123 -18 31 -28 57 -24 57 5 0 16 -15 25 -32z m578 17 c7 -8 9 -15 6 -15
-4 0 -14 7 -22 15 -9 8 -11 15 -6 15 5 0 15 -7 22 -15z m-660 -100 c5 -11 16
-40 24 -65 8 -25 17 -54 21 -65 6 -16 5 -17 -4 -5 -6 8 -18 40 -27 70 -10 30
-21 60 -25 65 -4 6 -10 33 -13 60 l-5 50 10 -45 c6 -25 15 -54 19 -65z m-378
34 c-11 -24 -21 -36 -21 -27 -1 9 4 20 9 23 6 3 10 20 10 38 0 22 3 28 11 20
8 -8 5 -23 -9 -54z m58 57 c0 -2 -7 -17 -15 -32 -16 -30 -19 -25 -9 14 5 18
24 33 24 18z m489 -23 c6 -16 21 -44 32 -63 l21 -35 -26 30 c-15 17 -29 40
-32 53 -4 12 -10 22 -15 22 -5 0 -9 5 -9 10 0 20 18 9 29 -17z m598 5 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-1375 -10 c-7 -7 -12 -8 -12
-2 0 6 3 14 7 17 3 4 9 5 12 2 2 -3 -1 -11 -7 -17z m4615 0 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-4432 -53 c-15 -31 -29 -55 -31 -52 -3 2
7 30 22 61 36 72 43 66 9 -9z m985 44 l25 -20 -32 16 c-18 8 -33 18 -33 20 0
10 16 4 40 -16z m-1823 -11 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m950 0 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m30 -10 c-3
-7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-207 12 c0 -5 -5 -10 -11
-10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m480 -129 c6 -24 9 -45 7
-47 -7 -7 -47 139 -46 166 0 25 16 -22 39 -119z m465 99 c21 -22 36 -40 32
-40 -7 0 -77 68 -77 75 0 10 6 4 45 -35z m-1385 26 c0 -2 -7 -7 -16 -10 -8 -3
-12 -2 -9 4 6 10 25 14 25 6z m1435 -6 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10
-3 6 -2 10 4 10 5 0 13 -4 16 -10z m3491 -17 c-10 -10 -19 5 -10 18 6 11 8 11
12 0 2 -7 1 -15 -2 -18z m-4594 -5 c-7 -7 -12 -8 -12 -2 0 6 3 14 7 17 3 4 9
5 12 2 2 -3 -1 -11 -7 -17z m537 -28 c0 -9 -4 -8 -9 5 -5 11 -9 27 -9 35 0 9
4 8 9 -5 5 -11 9 -27 9 -35z m451 40 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3
6 -1 10 4 10 6 0 11 -4 11 -10z m-589 -225 l-10 -70 4 79 c3 43 6 111 7 150
l2 71 3 -80 c2 -44 -1 -111 -6 -150z m-321 185 c-6 -12 -14 -20 -17 -17 -2 3
1 14 8 26 7 11 15 18 17 16 2 -2 -2 -13 -8 -25z m26 -27 c-14 -26 -25 -44 -26
-39 0 13 43 97 47 92 3 -2 -7 -26 -21 -53z m138 30 c-4 -16 -13 -41 -21 -58
l-14 -30 6 30 c6 34 25 85 31 85 3 0 1 -12 -2 -27z m33 5 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m30 -25 c-3 -10 -5 -2 -5 17 0 19 2 27 5
18 2 -10 2 -26 0 -35z m387 -3 l6 -35 -14 35 c-17 42 -20 58 -7 45 5 -6 12
-26 15 -45z m-1315 -5 c0 -5 -4 -3 -9 5 -5 8 -9 22 -9 30 0 16 17 -16 18 -35z
m1652 18 l24 -26 -27 19 c-15 10 -28 22 -28 27 0 12 5 8 31 -20z m124 17 c3
-6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m3422 -12 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-4553 -12 c-3 -9 -12 -16 -20 -16
-11 0 -10 4 3 20 19 22 26 21 17 -4z m352 -13 c-11 -11 -17 4 -9 23 7 18 8 18
11 1 2 -10 1 -21 -2 -24z m544 27 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6
5 10 10 10 6 0 10 -4 10 -10z m-724 -27 c-10 -10 -19 5 -10 18 6 11 8 11 12 0
2 -7 1 -15 -2 -18z m141 5 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m847 6 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m-274 -55
c0 -18 -10 -8 -25 24 l-16 32 21 -24 c11 -13 20 -27 20 -32z m30 36 c0 -8 -2
-15 -4 -15 -2 0 -6 7 -10 15 -3 8 -1 15 4 15 6 0 10 -7 10 -15z m-427 -40 c4
-27 3 -35 -3 -25 -5 8 -10 28 -10 44 0 39 6 30 13 -19z m42 -15 c4 -29 3 -40
-3 -30 -13 21 -24 96 -12 84 5 -5 12 -29 15 -54z m299 38 c10 -39 7 -44 -9
-14 -17 33 -18 36 -6 36 5 0 11 -10 15 -22z m-721 -3 c-3 -9 -8 -14 -10 -11
-3 3 -2 9 2 15 9 16 15 13 8 -4z m37 -25 c-7 -17 -15 -28 -18 -26 -2 3 1 19 8
36 7 17 15 28 18 26 2 -3 -1 -19 -8 -36z m79 -25 c-7 -31 -17 -59 -22 -62 -6
-4 -7 3 -3 18 4 13 13 43 19 66 15 63 21 44 6 -22z m91 53 c0 -7 -7 -33 -15
-58 -13 -37 -14 -39 -10 -11 3 18 5 44 5 57 0 13 5 24 10 24 6 0 10 -6 10 -12z
m27 -25 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m654 10 c13
-16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m-282 -53 c0 -13 -1
-13 -8 0 -5 8 -12 26 -15 40 l-7 25 15 -25 c9 -14 15 -32 15 -40z m-769 30 c0
-5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m316 -46
c-4 -14 -9 -24 -12 -21 -3 2 -2 17 2 31 3 15 9 25 11 22 3 -3 2 -17 -1 -32z
m612 6 c13 -16 19 -30 14 -30 -4 0 -16 14 -25 30 -10 17 -16 30 -14 30 2 0 13
-13 25 -30z m3629 -3 c2 -25 0 -29 -8 -17 -8 12 -10 9 -6 -13 3 -21 1 -27 -9
-23 -8 3 -14 0 -14 -7 0 -7 -11 -25 -25 -42 -19 -23 -24 -26 -25 -12 0 10 6
20 14 23 8 3 16 17 19 32 5 23 42 92 49 92 2 0 4 -15 5 -33z m-4172 -112 c-4
-59 -11 -105 -17 -105 -6 0 -8 10 -5 23 3 12 9 61 13 110 4 48 9 85 12 83 2
-3 1 -53 -3 -111z m274 41 c2 -25 -18 13 -23 44 l-6 35 14 -35 c8 -19 15 -39
15 -44z m251 9 c0 -5 -9 4 -20 20 -11 17 -20 35 -20 40 0 6 9 -3 20 -20 11
-16 20 -34 20 -40z m-699 32 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11
-7 -18z m398 -32 c1 -17 -1 -17 -9 -5 -5 8 -9 26 -9 40 0 23 1 23 9 5 5 -11 9
-29 9 -40z m88 25 c6 -16 8 -30 3 -30 -4 0 -10 8 -14 18 -3 9 -9 23 -12 30 -3
6 -2 12 3 12 5 0 14 -13 20 -30z m-129 -70 l0 -35 -8 30 c-4 17 -8 46 -8 65
l0 35 8 -30 c4 -16 8 -46 8 -65z m188 45 c14 -34 18 -52 9 -44 -9 9 -35 79
-30 79 3 0 13 -16 21 -35z m279 -3 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3
15 -9 12 -12z m-948 -14 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m537 -51 c5 -27 4 -37 -3 -32 -6 3 -11 22 -11 42 0 44 5 41 14 -10z m311 33
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1395
-21 c0 -6 -4 -7 -10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z
m1310 -35 c0 -8 -4 -12 -10 -9 -5 3 -10 13 -10 21 0 8 5 12 10 9 6 -3 10 -13
10 -21z m-423 -46 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z
m263 17 c0 -17 -2 -17 -10 -5 -5 8 -10 24 -10 35 0 17 2 17 10 5 5 -8 10 -24
10 -35z m-113 3 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-1007
13 c0 -5 6 -16 13 -23 15 -16 47 -65 47 -73 0 -15 -20 -2 -25 18 -4 12 -15 31
-25 42 -25 30 -33 45 -21 45 6 0 11 -4 11 -9z m647 -13 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m593 -11 c0 -5 -4 -5 -10 -2 -5 3 -10 14 -10
23 0 15 2 15 10 2 5 -8 10 -19 10 -23z m3564 -91 c-3 -9 -10 -16 -15 -16 -5 0
-4 9 3 20 14 22 21 20 12 -4z m-4714 -26 c6 -11 7 -20 2 -20 -6 0 -12 9 -15
20 -3 11 -3 20 -1 20 2 0 8 -9 14 -20z m4685 -19 c-3 -6 -11 -11 -17 -11 -6 0
-6 6 2 15 14 17 26 13 15 -4z m-25 -35 c0 -8 -7 -16 -15 -20 -12 -4 -13 -2 -2
14 14 24 17 25 17 6z m-86 -116 c-26 -33 -51 -60 -56 -60 -5 0 0 12 12 28 11
15 28 38 37 52 29 43 47 62 51 51 2 -6 -18 -38 -44 -71z m-4510 53 c6 -14 9
-15 15 -4 7 11 11 9 20 -8 8 -14 8 -21 1 -21 -5 0 -10 5 -10 11 0 5 -5 7 -10
4 -9 -6 -40 17 -40 29 0 13 18 5 24 -11z m4613 -29 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m-173 -128 c-4 -12 -9 -12 -19 -3 -9 9 -9 16 -1
29 9 14 12 15 18 4 5 -8 5 -21 2 -30z m-4269 -11 c27 -26 30 -32 13 -25 -20
10 -66 60 -55 60 2 0 21 -16 42 -35z m4239 -27 c-3 -4 -12 -8 -20 -8 -8 0 -14
4 -14 8 0 4 9 8 19 8 11 0 17 -4 15 -8z m-64 -38 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-4033 -77 c44 -42 51 -52 28
-41 -26 14 -104 98 -91 98 3 0 31 -25 63 -57z m3948 -3 c-10 -11 -15 -23 -11
-27 4 -4 12 -1 17 7 9 13 10 13 6 0 -2 -9 -14 -14 -26 -13 -13 2 -20 -1 -16
-7 3 -6 -1 -10 -9 -10 -24 0 -20 12 16 46 36 34 53 37 23 4z m123 -35 c-1 -1
-13 -6 -26 -10 l-23 -7 23 27 c19 22 24 24 26 10 2 -9 2 -18 0 -20z m-3998
-35 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z
m3820 -14 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2
10 -4z m-3740 -55 c28 -28 52 -50 53 -50 10 1 37 -15 37 -22 0 -23 -39 -5 -79
36 -24 25 -49 45 -55 45 -6 0 -4 5 4 10 12 8 9 10 -12 10 -16 0 -28 5 -28 10
0 23 33 7 80 -39z m3699 35 c9 -11 8 -15 -6 -18 -30 -8 -45 1 -30 17 15 18 22
18 36 1z m-44 -32 c14 -6 13 -9 -6 -30 -28 -30 -49 -32 -23 -3 19 22 19 22 -6
15 -24 -7 -24 -6 -6 8 23 18 20 18 41 10z m-72 -40 c-7 -3 -11 -11 -9 -17 1
-7 1 -9 -2 -4 -2 4 -13 -4 -24 -18 -11 -14 -22 -24 -24 -22 -7 7 49 67 61 66
5 0 5 -3 -2 -5z m-3409 -96 c11 -10 16 -21 13 -25 -4 -3 -21 8 -38 25 -17 18
-35 32 -40 32 -5 0 -9 5 -9 11 0 12 40 -11 74 -43z m3476 32 c0 -5 -7 -10 -16
-10 -8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z m-150 -37 c0 -8 -5 -11
-10 -8 -6 3 -13 -1 -16 -9 -3 -9 -15 -16 -25 -16 -11 0 -22 -7 -25 -15 -4 -8
-10 -15 -16 -15 -5 0 -6 5 -3 10 10 16 -7 12 -27 -7 -10 -9 -21 -14 -24 -11
-3 3 9 16 25 28 17 12 31 18 31 14 0 -3 6 -1 14 5 8 6 19 10 26 9 7 -2 15 3
17 10 3 8 -1 10 -14 6 -16 -6 -16 -5 2 9 22 17 45 12 45 -10z m-3223 -61 c32
-21 83 -52 113 -68 30 -15 69 -39 86 -51 17 -13 33 -23 37 -23 5 0 82 -35 203
-91 22 -10 44 -19 48 -19 4 0 22 -6 39 -14 105 -46 348 -113 507 -140 52 -9
121 -22 152 -28 31 -6 173 -11 315 -12 280 -1 413 10 601 51 86 18 117 21 127
13 10 -8 19 -9 32 -1 17 10 17 10 -2 11 -12 1 -4 7 20 15 22 8 49 12 60 10 11
-3 13 -2 6 2 -18 7 128 55 147 48 7 -3 11 -1 8 4 -8 13 37 29 70 25 23 -3 25
-2 9 4 -17 8 -12 11 31 26 34 11 58 14 74 8 17 -6 20 -11 11 -17 -8 -4 -17 -2
-21 5 -4 7 -13 9 -19 6 -6 -4 -9 -11 -7 -15 6 -10 -58 -41 -84 -41 -11 0 -20
-4 -20 -9 0 -9 -84 -41 -228 -85 -56 -17 -89 -23 -100 -17 -10 6 -20 4 -30 -6
-9 -8 -26 -13 -38 -10 -13 2 -21 1 -19 -4 3 -4 -14 -10 -37 -14 -24 -3 -77
-13 -118 -21 -126 -24 -138 -25 -370 -28 -267 -3 -456 12 -635 51 -38 9 -77
16 -85 17 -8 1 -33 8 -55 15 -76 24 -71 21 -55 32 11 7 8 8 -11 4 -33 -8 -127
21 -157 49 -18 16 -25 18 -31 7 -5 -8 -11 -9 -15 -3 -3 6 0 13 6 15 7 3 3 6
-9 6 -12 1 -25 6 -28 11 -3 6 -11 10 -17 10 -5 0 0 -9 13 -20 13 -10 20 -19
14 -19 -20 1 -129 58 -115 60 8 1 -3 5 -25 8 -24 4 -39 11 -37 19 1 6 -6 12
-17 12 -34 0 -78 21 -90 43 -6 12 -9 14 -7 5 3 -10 1 -18 -4 -18 -6 0 -10 4
-10 9 0 5 -13 12 -30 16 -16 4 -29 10 -29 13 4 25 -3 33 -21 27 -14 -5 -20 -2
-20 10 0 10 -7 14 -22 12 -13 -2 -17 -2 -10 0 10 4 10 8 1 19 -9 11 -15 11
-25 3 -14 -12 -38 -3 -29 11 3 4 -5 6 -17 2 -17 -4 -20 -2 -15 12 4 9 3 15 -1
12 -4 -2 -14 -1 -22 5 -12 7 -11 9 5 9 12 0 2 9 -27 23 -27 12 -48 25 -48 30
0 14 19 6 77 -31z m3227 -35 c6 -5 0 -5 -14 -1 -23 6 -24 5 -10 -11 14 -16 12
-17 -20 -10 -32 6 -33 6 -16 -7 17 -14 17 -15 -9 -32 -25 -17 -26 -17 -24 1 2
10 0 24 -4 30 -6 9 4 19 30 30 21 10 40 23 42 28 2 6 7 3 9 -5 3 -8 10 -19 16
-23z m-154 10 c30 8 24 -3 -12 -21 -18 -9 -41 -22 -50 -28 -9 -7 -21 -9 -25
-4 -4 4 3 16 16 25 14 9 30 21 35 28 6 6 12 7 14 3 2 -4 12 -6 22 -3z m-110
-57 c-8 -6 -22 -10 -30 -9 -9 0 -5 6 10 14 27 14 44 10 20 -5z m-2980 0 c8 -5
12 -11 10 -14 -3 -2 -14 2 -24 10 -22 15 -10 19 14 4z m3076 -19 c-3 -5 6 -12
19 -15 14 -4 23 -11 20 -15 -3 -5 -15 -7 -27 -3 -17 4 -20 2 -15 -11 8 -21
-11 -22 -36 -3 -18 14 -18 14 1 20 11 4 23 13 26 21 3 8 8 15 11 15 4 0 4 -4
1 -9z m61 3 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-203 -13
c15 -6 16 -9 5 -13 -8 -3 -20 1 -27 8 -14 15 -7 17 22 5z m-24 -23 c-1 -22
-84 -58 -114 -50 l-27 7 31 12 c16 6 30 7 30 2 0 -5 5 -9 11 -9 5 0 7 5 4 11
-8 13 23 38 48 39 9 0 17 -6 17 -12z m-40 -128 c0 -5 -4 -10 -10 -10 -5 0 -10
5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-35 -10 c3 -6 -1 -7 -9 -4 -18 7
-21 14 -7 14 6 0 13 -4 16 -10z m-1448 -6 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m1363 -14 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 1 10 9 10
9 0 16 -4 16 -9 0 -11 -25 -21 -51 -21 -11 0 -22 -7 -25 -15 -8 -19 -21 -19
-40 -1 -20 20 -18 26 9 26 12 0 29 5 37 10 19 13 30 13 30 0z"/>
<path d="M4348 7893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6020 7846 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
<path d="M6160 7800 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M6225 7760 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3930 7750 c-24 -15 -7 -18 20 -3 14 7 18 13 10 13 -8 0 -22 -4 -30
-10z"/>
<path d="M3875 7720 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3798 7683 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3715 7640 c-3 -5 1 -10 9 -10 8 0 18 5 21 10 3 6 -1 10 -9 10 -8 0
-18 -4 -21 -10z"/>
<path d="M6472 7630 c7 -10 14 -18 15 -16 6 6 -9 36 -18 36 -5 0 -4 -9 3 -20z"/>
<path d="M3595 7570 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3553 7523 c0 -10 7 -13 21 -9 12 3 24 6 29 6 4 0 7 3 7 8 0 4 -13 7
-28 8 -19 1 -29 -4 -29 -13z"/>
<path d="M3457 7482 c-27 -16 -36 -32 -18 -32 13 0 57 37 51 43 -3 3 -18 -2
-33 -11z"/>
<path d="M3400 7440 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M3420 7420 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M6870 7409 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3380 7399 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3232 7291 c-11 -7 -11 -9 2 -14 20 -8 48 2 40 14 -7 11 -25 11 -42
0z"/>
<path d="M4178 7053 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4058 7023 c34 -2 90 -2 125 0 34 2 6 3 -63 3 -69 0 -97 -1 -62 -3z"/>
<path d="M4423 7023 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M4528 7023 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4318 6973 c45 -2 119 -2 165 0 45 1 8 3 -83 3 -91 0 -128 -2 -82 -3z"/>
<path d="M3920 6930 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10z"/>
<path d="M3918 6793 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4588 6793 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3938 6653 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4498 6653 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M4338 6603 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M3913 6563 c8 -7 677 -6 685 2 3 3 -151 5 -343 5 -192 0 -345 -3
-342 -7z"/>
<path d="M3840 6518 c0 -5 174 -7 388 -6 213 1 358 3 322 5 -155 7 -710 7
-710 1z"/>
<path d="M3976 6467 c44 -4 195 -4 335 1 l254 9 -335 -1 c-231 -1 -310 -3
-254 -9z"/>
<path d="M4583 6473 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4160 6430 l-85 -6 122 -2 c72 -1 124 2 128 8 7 11 -21 11 -165 0z"/>
<path d="M4493 6423 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M4588 6423 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M3880 6380 c0 -6 131 -10 370 -10 220 0 370 4 370 10 0 5 -150 9
-370 10 -240 0 -370 -3 -370 -10z"/>
<path d="M3840 6350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4255 6340 c-187 -3 -335 -8 -330 -11 8 -5 557 -5 663 0 19 0 31 5
27 11 -3 6 -9 9 -13 8 -4 -2 -160 -5 -347 -8z"/>
<path d="M3859 6285 c15 -10 97 -11 615 -6 82 0 146 4 142 9 -4 4 -180 7 -390
7 -267 0 -378 -3 -367 -10z"/>
<path d="M3840 6247 c0 -9 11 -14 28 -14 369 -4 759 0 765 6 6 6 -154 10 -383
11 -216 0 -397 3 -402 6 -4 3 -8 -1 -8 -9z"/>
<path d="M3840 6206 c0 -8 8 -17 18 -19 27 -8 771 -2 779 6 3 4 -166 7 -376 7
-244 0 -389 4 -402 10 -15 8 -19 7 -19 -4z"/>
<path d="M3856 6155 c18 -12 83 -15 403 -17 251 -2 380 0 378 7 -2 6 -137 11
-373 12 -203 1 -382 5 -399 8 -29 5 -29 5 -9 -10z"/>
<path d="M3840 6109 c0 -4 7 -10 16 -13 27 -10 772 -7 779 4 4 6 -137 11 -395
12 -220 2 -400 0 -400 -3z"/>
<path d="M3883 6062 c-13 -2 -23 -6 -23 -10 0 -4 66 -7 148 -7 378 1 612 6
612 14 0 8 -683 11 -737 3z"/>
<path d="M4485 6019 c-77 -4 -249 -6 -383 -4 -270 4 -258 7 -260 -67 l-1 -38
399 0 c284 0 400 3 400 11 0 8 -55 10 -182 9 -360 -4 -608 0 -608 10 0 6 138
10 395 10 257 0 395 4 395 10 0 6 -136 10 -389 10 -366 0 -481 8 -339 24 35 4
211 7 393 6 398 -2 365 -3 365 16 0 14 -3 14 -15 4 -10 -9 -15 -9 -15 -1 0 6
-3 10 -7 9 -5 0 -71 -5 -148 -9z"/>
<path d="M4658 5679 c-2 -45 0 -83 5 -86 4 -2 7 34 7 81 0 47 -2 86 -4 86 -3
0 -6 -36 -8 -81z"/>
<path d="M2495 6490 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6865 6189 c-23 -63 -125 -376 -125 -386 0 -10 32 -13 135 -13 110 0
135 3 135 14 0 21 -120 380 -130 390 -6 6 -11 4 -15 -5z"/>
<path d="M5057 5053 c-4 -3 -7 -105 -7 -225 l0 -218 90 0 c162 0 183 28 178
238 -3 152 -14 181 -72 202 -32 11 -179 14 -189 3z"/>
<path d="M5845 4953 c-9 -32 -27 -91 -40 -131 -19 -57 -21 -74 -11 -78 7 -3
46 -4 87 -2 73 3 74 4 71 28 -6 41 -75 240 -83 240 -5 0 -16 -26 -24 -57z"/>
<path d="M7056 5000 c-34 -103 -76 -241 -76 -249 0 -7 31 -11 85 -11 71 0 85
3 85 16 0 17 -66 218 -81 244 -7 13 -8 13 -13 0z"/>
<path d="M6380 4120 l0 -80 85 0 c97 0 129 11 145 51 15 35 4 86 -20 99 -10 6
-62 10 -114 10 l-96 0 0 -80z"/>
<path d="M6380 3835 l0 -85 104 0 c121 0 146 12 148 70 3 86 -19 100 -158 100
l-94 0 0 -85z"/>
<path d="M3922 4218 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 -10 4 -14 1 -12
-6z"/>
<path d="M3930 4171 c0 -13 29 -35 37 -28 7 8 -15 37 -28 37 -5 0 -9 -4 -9 -9z"/>
<path d="M3850 4141 c0 -5 7 -14 15 -21 16 -14 18 -10 9 14 -6 17 -24 22 -24
7z"/>
<path d="M4038 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6198 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4235 2410 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M5968 2403 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4485 2336 c22 -7 42 -12 44 -10 8 7 -4 11 -44 17 l-40 6 40 -13z"/>
<path d="M5745 2340 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4568 2323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5658 2323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5418 2283 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M5048 2273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5228 2273 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M7840 2210 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
